export default __webpack_public_path__ + "static/media/share-icon-large.2d8cd90d.svg";